











































































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import {
  ConversationDto,
  GetCurrentMessagesRequest,
  CommunicationParty,
  MessageDto,
  MessageType,
  SendMessageToCustomerCommand,
  GetNewMessagesRequest,
  UpdateReadStatusCommand,
  TrackableMessageDto
} from "@/types/interface/IM/IMTypes";
import { toLocalTime, generateGUID } from "@/api/net/util";
import { utf16toEntities, uncodeUtf16 } from "@/api/net/util.ts";
import Badge from "@/components/Badge.vue";
import MessageRow from "./components/message-row.vue";
import {
  getRecentMessages,
  sendMessageToCustomer,
  getNewMessages,
  changeMessageReadStatus
} from "../../api/net/im";

import { getUploadInfo } from "../../api/php/im";

import { startSignalR } from "@/api/signalR";
import { AxiosResponse } from "axios";
import { Getter } from "vuex-class";
import { event } from "../../libs/utils";
import Header from "@/components/header.vue";
import { IWindowOptions, EventType } from "../../types/base/IWindowOptions";

import store from "../../store/index";
import { IOrderDto } from "../../types/interface/IOrderDto";
import { upLoadPhoto } from "../../api/php/im";

@Component({
  name: "conversation-details",
  components: {
    Badge,
    MessageRow,
    Header
  }
})
export default class ConversationDetails extends Vue {
  @Getter("headerTitle") headerTitle!: string;
  @Getter("newMessage") newMessage!: TrackableMessageDto;
  @Getter("options") options!: IWindowOptions;
  @Getter("orderList") orderList!: IOrderDto[];
  @Getter("isPc") isPc: boolean;
  @Getter("openInBrowser") openInBrowser!: boolean;
  @Watch("options", { immediate: true, deep: true })
  onOptionsChanged(options: IWindowOptions) {
    if (options.eventType === EventType.TakePhoto && options.meta.imageSrc) {
      this.sendMessage(MessageType.Photo, options.meta.imageSrc);
    }
  }
  @Watch("newMessage")
  onNewMessageArrived(newValue: TrackableMessageDto) {
    const container = this.$el.querySelector("#messagePanel") as Element;
    let isPushNewMessage =
      !this.messages.some(x => x.id === newValue.id) &&
      newValue.merchId === this.merchId &&
      (this.sendToUserId === newValue.sendToUserId ||
        this.sendToUserId === newValue.sendByUserId);
    if (isPushNewMessage) {
      newValue.content = uncodeUtf16(newValue.content);
      this.messages = [...this.messages, newValue];
      if (container.scrollHeight > window.innerHeight) {
        this.unreadNewMessages++;
      }
    }
    const isNewMessageSendByCustomer: boolean =
      this.messages[this.messages.length - 1].sendByParty ===
      CommunicationParty.customer;
    if (isNewMessageSendByCustomer) {
      this.markMessagesAsRead();
    }
    const scrollBottom: number =
      container.scrollHeight - container.scrollTop - container.clientHeight;
    if (scrollBottom <= 1 && isPushNewMessage) {
      this.scrollToBottom();
    }
  }
  merchId: string = "";
  orderId: string | null = null;
  sendToUserId: string = "";
  messages: TrackableMessageDto[] = [];
  messagePanelHeight: number = document.body.offsetHeight - 200;
  messageContent: string | null = null;
  timer: number = 1000;
  inThrottle: boolean = false;
  pageIndex: number = 0;
  showSendPCPhotoDialog: boolean = false;
  photoFile: any = null;
  upLoadInfo: {
    bucket: string;
    origin: string;
    token: string;
  } = {
    bucket: "",
    origin: "",
    token: ""
  };
  unreadNewMessages: number = 0;
  actionHeight: number = 0;

  owned(item: MessageDto) {
    return item.sendByParty === CommunicationParty.merchant;
  }
  sortedMessages(messages: TrackableMessageDto[]) {
    return messages.sort(
      (a, b) => new Date(a.sendTime).getTime() - new Date(b.sendTime).getTime()
    );
  }

  public get isOpenInBrowser(): boolean {
    return this.$store.state.openInBrowser;
  }

  async loadRecentMessages(isMarkMessagesAsRead: boolean = true) {
    let orderId: string = this.$route.query.orderId as string;
    let toUserId: string = this.$route.query.toUserId as string;
    let merchId: string = this.$route.query.merchId as string;
    this.orderId = orderId;
    this.sendToUserId = toUserId;
    this.merchId = merchId;

    const request: GetCurrentMessagesRequest = {
      communicationTo: this.sendToUserId,
      communicationToParty: CommunicationParty.customer,
      requestFrom: CommunicationParty.merchant,
      orderId: this.orderId,
      pageIndex: 0,
      pageSize: 50
    };

    const recentMessages = await getRecentMessages(request, this.merchId);
    this.messages = this.sortedMessages(recentMessages);
    this.messages.filter(x => (x.content = uncodeUtf16(x.content)));
    store.commit("handleShowLoading", false);
    if (isMarkMessagesAsRead) {
      this.markMessagesAsRead();
    }
  }

  async loadPreviousMessages() {
    let orderId: string = this.$route.query.orderId as string;
    let toUserId: string = this.$route.query.toUserId as string;
    let merchId: string = this.$route.query.merchId as string;
    this.orderId = orderId;
    this.sendToUserId = toUserId;
    this.merchId = merchId;

    const request: GetCurrentMessagesRequest = {
      communicationTo: this.sendToUserId,
      communicationToParty: CommunicationParty.customer,
      requestFrom: CommunicationParty.merchant,
      orderId: this.orderId,
      pageIndex: this.pageIndex,
      pageSize: 50
    };

    const previousMessages = await getRecentMessages(request, this.merchId);
    this.messages = this.sortedMessages([
      ...this.messages,
      ...previousMessages
    ]);
    this.messages.filter(x => (x.content = uncodeUtf16(x.content)));
    store.commit("handleShowLoading", false);
  }

  async markMessagesAsRead() {
    const request: UpdateReadStatusCommand = {
      orderId: this.orderId,
      userId: this.sendToUserId,
      commandFrom: CommunicationParty.merchant,
      merchId: this.merchId
    };
    await changeMessageReadStatus(request);
  }

  async sendMessage(type: MessageType, attachmentId: string | null = null) {
    if (!this.messageContent && type === MessageType.Text) return;
    if (type === MessageType.Photo) {
      this.messageContent = "";
    }

    const messageId = generateGUID();
    const trackableMessage = this.generateTrackableMessage(messageId);
    this.messages = [...this.messages, trackableMessage];
    attachmentId = attachmentId
      ? attachmentId.substring(attachmentId.lastIndexOf("/") + 1)
      : "";
    const postData: SendMessageToCustomerCommand = {
      sendToUserId: this.sendToUserId,
      messageId,
      attachmentId,
      content: utf16toEntities(this.messageContent),
      type,
      orderId: this.orderId,
      commandFrom: CommunicationParty.merchant
    };

    this.messageContent = "";
    const response = await sendMessageToCustomer(postData, this.merchId);
    this.scrollToBottom();
    if (response.status >= 400) {
      trackableMessage.hasError = true;
    } else if (response.status === 200) {
      await this.loadRecentMessages(false);
    }
  }

  opemCamera() {
    event("takePhoto", "");
  }

  generateTrackableMessage(messageId: string) {
    const merchMessages = this.messages.filter(
      x => x.sendByParty === CommunicationParty.merchant
    );
    const merchMessage = merchMessages.some(x => true)
      ? merchMessages[merchMessages.length - 1]
      : null;
    let sendTime;
    try {
      sendTime = this.messages[this.messages.length - 1].sendTime;
    } catch {
      sendTime = new Date();
    }
    const trackableMessage: TrackableMessageDto = {
      id: messageId,
      sendByParty: CommunicationParty.merchant,
      sendToParty: CommunicationParty.customer,
      type: MessageType.Text,
      content: this.messageContent,
      attachmentId: "",
      orderId: this.orderId,
      merchId: "",
      sendToUserId: this.sendToUserId,
      sendToHeadPicture: "",
      sendByUserId: "",
      sendByHeadPicture: merchMessage ? merchMessage.sendByHeadPicture : "",
      isReaded: false,
      sendTime: sendTime,
      isLoading: true,
      nameOfSendTo: "",
      nameOfSendBy: "",
      hasError: false,
      orderSerialNumber: ""
    };
    return trackableMessage;
  }

  async getNewMessages() {
    const lastRequestedTime = this.messages[this.messages.length - 1].sendTime;
    const newMessagesRequest: GetNewMessagesRequest = {
      communicationToParty: CommunicationParty.customer,
      requestFrom: CommunicationParty.merchant,
      communicationTo: this.sendToUserId,
      orderId: this.orderId,
      lastRequestedTime
    };
    const newMessages: TrackableMessageDto[] = (
      await getNewMessages(newMessagesRequest)
    ).filter(
      x =>
        new Date(x.sendTime).getTime() - new Date(lastRequestedTime).getTime()
    );

    this.markPreviousSentMessageAsFinishedLoading(newMessages);
    this.messages = this.removeDuplicate([...this.messages, ...newMessages]);
  }

  markPreviousSentMessageAsFinishedLoading(newMessages: TrackableMessageDto[]) {
    newMessages.forEach(x => {
      const messageJustSent = this.messages.find(m => m.id === x.id);
      if (messageJustSent) {
        messageJustSent.isLoading = false;
      }
    });
  }

  removeDuplicate(messages: TrackableMessageDto[]) {
    return Array.from(new Set(messages.map(x => x.id))).map(y => {
      return messages.find(z => z.id === y);
    }) as TrackableMessageDto[];
  }

  scrollToBottom() {
    this.$nextTick(() => {
      const container = this.$el.querySelector("#messagePanel");
      if (container) {
        container.scrollTop = container.scrollHeight;
      }
    });
  }

  resize() {
    this.messagePanelHeight = document.body.offsetHeight - 140;
    window.onresize = () => {
      this.messagePanelHeight = document.body.offsetHeight - 140;
    };
  }

  toOrder(orderId: string) {
    this.$router.push({
      path: `order-detail?orderId=${orderId}`,
      query: {
        from: `Conversation`
      }
    });
  }

  clickSendMessages() {
    this.throttle(() => {
      this.sendMessage(0);
    }, this.timer);
  }

  throttle(callback: Function, outTime: number) {
    if (!this.inThrottle) {
      callback();
      this.inThrottle = true;
      setTimeout(() => {
        this.inThrottle = false;
      }, outTime);
    }
  }

  messageSendTime(time: string): string {
    return toLocalTime(new Date(time));
  }

  showSendTime(messageId: string): boolean {
    let messageIndex: number = this.messages.findIndex(
      (item: TrackableMessageDto, index: number) => {
        return item.id === messageId;
      }
    );
    const messageInSameMinutes: boolean = (messageIndex > 0 &&
      this.messages[messageIndex].sendTime &&
      new Date(this.messages[messageIndex].sendTime).getMinutes() ===
        new Date(this.messages[messageIndex - 1].sendTime).getMinutes() &&
      new Date(this.messages[messageIndex].sendTime).getHours() ===
        new Date(this.messages[messageIndex - 1].sendTime).getHours() &&
      new Date(this.messages[messageIndex].sendTime).getDate() ===
        new Date(this.messages[messageIndex - 1].sendTime).getDate() &&
      new Date(this.messages[messageIndex].sendTime).getMonth() ===
        new Date(
          this.messages[messageIndex - 1].sendTime
        ).getMonth()) as boolean;
    if (messageInSameMinutes) {
      return false;
    }
    return true;
  }

  public get userOrderScores(): Array<{
    good: number;
    bad: number;
    icon: string;
  }> {
    if (this.$route.query.userOrderScores) {
      return JSON.parse(this.$route.query.userOrderScores as string);
    } else {
      return [
        { icon: "mdi-storefront", good: 0, bad: 0 },
        { icon: "yamimeal", good: 0, bad: 0 }
      ];
    }
  }

  async handleScroll() {
    const container = this.$el.querySelector("#messagePanel") as Element;
    let currentHeight: number = container.scrollHeight as number;
    if (container && container.scrollTop === 0) {
      let previousHeight: number = container.scrollHeight;
      this.pageIndex++;
      store.commit("handleShowLoading", true);
      await this.loadPreviousMessages();
      currentHeight = container.scrollHeight;
      container.scrollTop = currentHeight - previousHeight;
    }

    const scrollBottom: number =
      container.scrollHeight - container.scrollTop - container.clientHeight;
    if (scrollBottom <= 1) {
      this.unreadNewMessages = 0;
    }
  }

  openPhotoDialog() {
    this.showSendPCPhotoDialog = true;
  }

  async sendPhotoInPC() {
    if (!this.photoFile) {
      return;
    }
    let formData = new FormData();
    formData.append("token", this.upLoadInfo.token);
    formData.append("file", this.photoFile);
    try {
      this.showSendPCPhotoDialog = false;
      let { status, data } = await upLoadPhoto(formData);
      if (status * 1 === 200) {
        let { hssh, key } = data;
        let imgSrc = `${this.upLoadInfo.origin}/${key}`;
        this.sendMessage(MessageType.Photo, imgSrc);
      }
    } catch (e) {
    } finally {
      this.photoFile = null;
    }
  }

  async getUploadInfo() {
    let { code, data } = await getUploadInfo();
    if (code * 1 === 0) {
      let { token, origin, bucket } = data;
      this.upLoadInfo = {
        token,
        origin,
        bucket
      };
    }
  }

  async mounted() {
    this.resize();
    store.commit("handleShowLoading", true);
    this.getUploadInfo();
    await this.loadRecentMessages();
    document.addEventListener("scroll", this.handleScroll, true);
    this.scrollToBottom();
    this.actionHeight = (this.$refs.actions as Element).offsetHeight;
  }

  beforeDestroy() {
    document.removeEventListener("scroll", this.handleScroll, true);
  }

  destroyed() {
    document.removeEventListener("scroll", this.handleScroll, true);
  }
}
